/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createNode } from '../../factoriesNumber.js';
export var NodeDependencies = {
  createNode
};